import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/noAuthApiClient';
//TODO: setup API client properly
const BASE_URL = 'https://private.hubapiqa.com/commerce-billing-portal/v1/debug';
import { MOCK_SUBSCRIPTIONS, MOCK_INVOICES } from './data/mockData';
const GET_INVOICES = registerQuery({
  fieldName: 'invoices',
  args: ['email', 'portalId', 'limit', 'after'],
  async fetcher({
    email,
    portalId,
    limit,
    after
  }) {
    try {
      if (!email || !portalId) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve({
              results: MOCK_INVOICES
            });
          }, 500);
        });
      }
      const params = new URLSearchParams({
        portalId: String(portalId),
        email
      });
      if (limit != null) {
        params.append('limit', String(limit));
      }
      if (after) {
        params.append('after', after);
      }
      const response = await http.get(`${BASE_URL}/invoices?${params.toString()}`);
      return response;
    } catch (error) {
      console.error(error);
      return {
        results: []
      };
    }
  }
});
const GET_SUBSCRIPTIONS = registerQuery({
  fieldName: 'subscriptions',
  args: ['email', 'portalId', 'limit', 'after'],
  async fetcher({
    email,
    portalId,
    limit,
    after
  }) {
    try {
      if (!email || !portalId) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve({
              results: MOCK_SUBSCRIPTIONS
            });
          }, 500);
        });
      }
      const params = new URLSearchParams({
        portalId: String(portalId),
        email
      });
      if (limit != null) {
        params.append('limit', String(limit));
      }
      if (after) {
        params.append('after', after);
      }
      const response = await http.get(`${BASE_URL}/subscriptions?${params.toString()}`);
      return response;
    } catch (error) {
      console.error(error);
      return {
        results: []
      };
    }
  }
});
const GET_SETTINGS = registerQuery({
  fieldName: 'settings',
  async fetcher() {
    try {
      const response = await http.get(`${BASE_URL}/settings`);
      return response;
    } catch (error) {
      console.error(error);
      return {
        pageTitle: 'Billing Portal'
      };
    }
  }
});
export { GET_INVOICES, GET_SUBSCRIPTIONS, GET_SETTINGS };